import {merge} from "../../util/common";
import {HeaderBuilder} from "../../util/athub-axios/header";
import {RestResource} from "./index";

export const getBillingPueAthubConfig = (athubConfig) => {
    return merge(true, {}, HeaderBuilder.getHeadersByBilling(), athubConfig);
};

export class BillingPueRestResource extends RestResource {
    constructor({server, resource}) {
        super({server, resource});
    }

    getAll (athubConfig) {
        return super.getAll(getBillingPueAthubConfig(athubConfig));
    }

    add (model, athubConfig) {
        return super.add(model, getBillingPueAthubConfig(athubConfig));
    }

    batchAdd (models, athubConfig) {
        return super.batchAdd(models, getBillingPueAthubConfig(athubConfig));
    }

    get (id, athubConfig) {
        return super.get(id, getBillingPueAthubConfig(athubConfig));
    }

    update (id, model, athubConfig) {
        return super.update(id, model, getBillingPueAthubConfig(athubConfig));
    }

    delete (id, athubConfig) {
        return super.delete(id, getBillingPueAthubConfig(athubConfig));
    }

    list (search, athubConfig) {
        return super.list(search, getBillingPueAthubConfig(athubConfig));
    }

    page (pageSearch, athubConfig) {
        return super.page(pageSearch, getBillingPueAthubConfig(athubConfig));
    }

    count (search, athubConfig) {
        return super.count(search, getBillingPueAthubConfig(athubConfig));
    }
}